import React from 'react';
import './about.css';
import About from '../../assets/avatar-3.png';
import AboutBox from './AboutBox';

const about = () => {
	return (
		<section
			className='about container section'
			id='about'
		>
			<h2 className='section__title'> About Me </h2>
			<div className='about__container'>
				<img
					src={About}
					alt=''
					className='about__img'
				/>
				<div className='about__data'>
					<div className='about__info'>
						<p className='about__description'>
							<h2>Hello again! 👋</h2>
							<br />
							I’m Argie, but my friends call me Arj. I’m a self-taught UX
							designer and Front-end Developer with a Bachelor’s degree in
							Information Technology. Over the past 4 years, I’ve held various
							job roles, such as Technical Support, Web Developer, and Front-end
							Developer. Recently, I’ve developed a strong fascination with the
							design field, so I decided to dive in and learn UX design on my
							own. I completed the Google UX Design course and now have a solid
							understanding of the design process.
							<br />
							<br />
							I’ve also become interested in logo design and brand identity and
							am eager to learn and explore more in this area. My front-end
							development experience allows me to effectively combine design
							with implementation, delivering solutions that are both creative
							and technically feasible.
							<br />
							<br />
							In addition, I have a growing interest in cloud computing, having
							earned four AWS certifications in the past 3 months. This
							demonstrates my willingness and eagerness to learn in any field
							I’m involved in. I’d say I’m a generalist—or a jack-of-all-trades,
							if you will.
							<br />
							<br />
							When I'm not knee-deep in my computer, you can find me
							binge-watching Netflix action/comedy films, reading books, taking
							photographs, or playing chess on my phone. I’m a team player,
							always challenging myself and open to new and exciting
							opportunities. Let’s chat! Feel free to message me at&nbsp;
							<a href='mailto:lumapac.argie@gmail.com'>
								lumapac.argie@gmail.com
							</a>
							.
						</p>
					</div>
				</div>
			</div>
			{/* <AboutBox /> */}
		</section>
	);
};

export default about;
